<template>
	<router-view :key="$route.fullPath"></router-view>
</template>
<script>
import { mapGetters } from 'vuex';
import { GridsGetters, AuthGetterTypes } from '../../store/getters';
import { gridViewTypes } from '../../enums/gridViewTypes';
import { GridsPageActions } from '../../store/actions';
export default {
	name: 'GridsPage',
	computed: {
		...mapGetters({
			gridViews: [GridsGetters.GET_GRID_VIEWS],
			currentUser: [AuthGetterTypes.CURRENT_USER],
		}),
		currentEntity() {
			return this.$route.params.pageName;
		},
	},
	watch: {
		currentEntity: function () {
			this.getCurrentGrid();
		},
	},
	created() {
		this.getCurrentGrid();
	},
	destroyed() {
		this.$store.dispatch(GridsPageActions.CLEAR);
	},
	methods: {
		getCurrentGrid() {
			let defaultView = this.gridViews.find(
				(grid) =>
					grid.Entity.Name === this.currentEntity &&
					grid.UserId == this.currentUser.userId &&
					grid.Type == gridViewTypes.Grids &&
					grid.IsDefault == true
			);
			if (defaultView) {
				this.$store.dispatch(
					GridsPageActions.LOAD_GRID_VIEW,
					defaultView
				);

				return defaultView;
			}

			let currentView = this.gridViews.find(
				(grid) =>
					grid.Entity.Name === this.currentEntity &&
					grid.UserId == null &&
					grid.Type == gridViewTypes.Grids
			);
			if (!currentView) {
				currentView = this.gridViews.find(
					(grid) => grid.Entity.Name === this.currentEntity
				);
			}

			this.$store.dispatch(GridsPageActions.LOAD_GRID_VIEW, currentView);
			return currentView;
		},
	},
};
</script>
